import { useState, useCallback } from 'react';

interface UseTemplateToggleReturn {
  confirmOpen: boolean;
  setConfirmOpen: (open: boolean) => void;
  handleToggleUpdate: () => void;
}

export const useTemplateToggle = (): UseTemplateToggleReturn => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleToggleUpdate = useCallback(() => {
    setConfirmOpen(true);
  }, []);

  return {
    confirmOpen,
    setConfirmOpen,
    handleToggleUpdate,
  };
};
